import { render, staticRenderFns } from "./myCardsixth.vue?vue&type=template&id=11bbfc1a&scoped=true"
import script from "./myCardsixth.vue?vue&type=script&lang=js"
export * from "./myCardsixth.vue?vue&type=script&lang=js"
import style0 from "./myCardsixth.vue?vue&type=style&index=0&id=11bbfc1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bbfc1a",
  null
  
)

export default component.exports